import { Trans } from '@lingui/react/macro';
import { selectTeams } from 'modules/overlay-v2/store/game-info/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { DivProps } from 'typings';
import UDText from 'ud-ui/components/text';
import PlayerItem from './player-item';
import { theme } from 'styles/theme/theme';

interface IProps extends DivProps {
  teamIndex: number;
}

function PlayersList(props: IProps) {
  const { teamIndex, className, ...rest } = props;
  const teams = useSelector(selectTeams);
  const team = teamIndex === 0 ? teams?.first : teams?.second;

  const players = useMemo(() => {
    return team?.members ?? [];
  }, [team]);

  const inGame = useMemo(() => {
    return players.filter((player) => player.isInvolved);
  }, [players]);

  const other = useMemo(() => {
    return players.filter((player) => !player.isInvolved);
  }, [players]);

  return (
    <div className={'flex flex-col gap-2 ' + className} {...rest}>
      <div className={'flex flex-row gap-2'}>
        <UDText style={{ width: 32, textAlign: 'center' }} type={'tip'} color={theme.colors.Gray}>
          <Trans>Аватар</Trans>
        </UDText>
        <UDText style={{ width: 28, textAlign: 'center' }} type={'tip'} color={theme.colors.Gray}>
          <Trans>Номер</Trans>
        </UDText>
        <UDText style={{ flexGrow: 1, textAlign: 'center' }} type={'tip'} color={theme.colors.Gray}>
          <Trans>Фио</Trans>
        </UDText>
        <UDText style={{ width: 28, textAlign: 'center' }} type={'tip'} color={theme.colors.Gray}>
          <Trans>Гол</Trans>
        </UDText>
        <UDText style={{ width: 28, textAlign: 'center' }} type={'tip'} color={theme.colors.Gray}>
          <Trans>ЖК</Trans>
        </UDText>
        <UDText style={{ width: 28, textAlign: 'center' }} type={'tip'} color={theme.colors.Gray}>
          <Trans>КК</Trans>
        </UDText>
      </div>
      {inGame.length > 0 && (
        <>
          <UDText color={theme.colors.Gray} style={{ textAlign: 'center', width: '100%' }} type={'tip'}>
            <Trans>В игре</Trans>
          </UDText>
          {inGame.map((player) => {
            return <PlayerItem key={player.id} player={player} />;
          })}
        </>
      )}
      {other.length > 0 && (
        <>
          <UDText color={theme.colors.Gray} style={{ textAlign: 'center', width: '100%' }} type={'tip'}>
            <Trans>Не заявлены</Trans>
          </UDText>
          {other.map((player) => {
            return <PlayerItem key={player.id} player={player} />;
          })}
        </>
      )}
    </div>
  );
}

export default PlayersList;
